import { DashboardSummaryData } from 'interfaces/Dashboard';

export const reverseKeyValueObject = (object: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(object).map(([key, value]) => [value, key])
  );
};

export function isEmpty(obj: any) {
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) return false;
  }
  return true;
}

export function toValueLabel(value: string) {
  return {
    value: value,
    label: value,
  };
}

export const calculateBudgetPercentage = (item: DashboardSummaryData) => {
  if (item.budgetTotal === 0 && item.realizedTotal === 0) {
    return 0;
  } else if (item.budgetTotal === 0) {
    return 100;
  } else {
    const percentage = (item.realizedTotal / item.budgetTotal) * 100;
    return Number(percentage.toFixed(2));
  }
};

export type ObjectWithNonNullableKey<O, K extends keyof O> = Omit<O, K> &
  Record<K, NonNullable<O[K]>>;
